/* Tracking Target Data Service
 *
 * Angular Module: trackerbase-app.services.tracking-target-data-service
 * Injected Service: TrackingTargetData
 */

import angular from "angular";
import ngResource from "angular-resource";

import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";
import TrackingTargetFactoryModule from "../models/factories/TrackingTargetFactory";

import Assert from "tbAssert";

function TrackingTargetDataServiceFactory($resource, TrackingTargetFactory, TbAppConfigDataService) {

    Assert.StrictAssert($resource != null, "Assertion Failure: Missing ngResource Service Dependency");
    Assert.StrictAssert(TrackingTargetFactory != null, "Assertion Failure: Missing Tracking Target Factory Service Dependency");
    Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

    const processTrackingTargetData = (serverResponse) => {
        let trackingTargetsData =
            serverResponse.data.Items.map(function(serverTT) {
                return TrackingTargetFactory.FromServerTrackingTarget(serverTT);
            });

        serverResponse.resource.queryResults = trackingTargetsData;

        return serverResponse.resource;
    };

    const processSingleTrackingTarget = (serverResponse) => {
        let trackingTarget = TrackingTargetFactory.FromServerTrackingTarget(serverResponse.data);
        serverResponse.resource.trackingTarget = trackingTarget;

        return serverResponse.resource;
    };

    const processMultipleTrackingTargets = (serverResponse) => {
        let trackingTargetData = serverResponse.data;
        serverResponse.resource.trackingTargets = trackingTargetData.map(
            function(serverTrackingTarget) {
                return TrackingTargetFactory.FromServerTrackingTarget(serverTrackingTarget);
            }
        );

        return serverResponse.resource;
    };

    const trackingTargetApiBaseUrl = `${TbAppConfigDataService.tbServerBaseUrl}/api/trackingtargets`;

    return $resource(
        trackingTargetApiBaseUrl,
        {},
        {
            getTargets: {
                url: trackingTargetApiBaseUrl,
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processTrackingTargetData
                }
            },
            get: {
                url: trackingTargetApiBaseUrl + "/:targetId",
                params: {targetId: "@targetId"},
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            },
            getDetailed: {
                url: trackingTargetApiBaseUrl + "/:targetId/details",
                params: {targetId: "@targetId"},
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            },
            getBatch: {
                url: trackingTargetApiBaseUrl + "/batch/:targetIds",
                params: { targetIds: "@targetIds" },
                method: "GET",
                isArray: true,
                responseType: "json",
                interceptor: {
                    response: processMultipleTrackingTargets
                }
            },
            query: {
                url: trackingTargetApiBaseUrl + "/search/:lastName",
                params: {lastName: "@lastName"},
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processTrackingTargetData
                }
            },
            queryStartsWith: {
                url: trackingTargetApiBaseUrl + "/beginswith/:lastName",
                params: {lastName: "@lastName"},
                method: "GET",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processTrackingTargetData
                }
            },
            addSubscription: {
                url: trackingTargetApiBaseUrl + "/:targetId/subscribers/:recipientId",
                params: {targetId: "@targetId", recipientId: "@recipientId"},
                method: "PUT",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            },
            removeSubscription: {
                url: trackingTargetApiBaseUrl + "/:targetId/subscribers/:recipientId",
                params: {targetId: "@targetId", recipientId: "@recipientId"},
                method: "DELETE",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            },
            create: {
                url: trackingTargetApiBaseUrl,
                params: {},
                method: "POST",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            },
            update: {
                url: trackingTargetApiBaseUrl + "/:targetId",
                params: {targetId: "@targetId"},
                method: "PATCH",
                isArray: false,
                responseType: "json",
                interceptor: {
                    response: processSingleTrackingTarget
                }
            }
        });
}

TrackingTargetDataServiceFactory.$inject = [ "$resource", "TrackingTargetFactory", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.tracking-target-data-service", [
        ngResource,
        TrackingTargetFactoryModule,
        TbAppConfigDataServiceModule
    ])
    .factory("TrackingTargetData", TrackingTargetDataServiceFactory)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/TrackingTargetDataService.js
// module id = dxOQ
// module chunks = 1